(function() {
    'use strict';

    angular.module('competence')
        .controller('CompetenceUpdateController', CompetenceUpdateController);

    CompetenceUpdateController.$inject = ['$state', 'notificationSrvc', 'competenceDataSrvc', 'competenceMessagesConst', 'productCountryConst', 'errorNotificationSrvc'];

    function CompetenceUpdateController($state, notificationSrvc, competenceDataSrvc, competenceMessagesConst, productCountryConst, errorNotificationSrvc) {
        var self = this;

        self.serverErrors = {
            name_pl: [],
            name_en: [],
            name_de: [],
            name_cpen: [],
            name_cpde: [],
            country: [],
            reclamation: [],
            complaint_reason: [],
            negotiations: [],
            nonFieldErrors: []
        };
        self.competenceData = {
            name_pl: '',
            name_de: '',
            name_en: '',
            name_cpde: '',
            name_cpen: '',
            country: '',
            reclamation: '',
            complaint_reason: '',
            negotiations: ''
        };
        self.countriesList = productCountryConst;
        self.updateCompetence = updateCompetence;
        self.cleanErrors = cleanErrors;

        activate();

        function activate() {
            getCompetence();
        }

        function getCompetence() {
            return competenceDataSrvc.get({
                pk: $state.params.pk
            }).$promise.then(function (response) {
                self.competenceData = response;

                delete self.competenceData.date_modified;
                delete self.competenceData.date_added;
                return response;
            });
        }

        function updateCompetence() {
            competenceDataSrvc.update({
                pk: self.competenceData.pk
            }, self.competenceData).$promise.then(
                function (response) {
                    notificationSrvc.notification("success", competenceMessagesConst.update);
                    $state.go('layout.competence.list');
                },
                function (response) {
                    errorNotificationSrvc.displayErrors(response.data);
                    self.serverErrors = response.data;
                }
            );
        }

        function cleanErrors(key) {
            self.serverErrors[key] = [];
        }

    }
})();
